// Components
import { useRouter } from 'next/router'
import Button from '../mawooButton'
import s from './Why.module.scss'

type Feature = {
  title: string
  icon: string
}

const features: Feature[] = [
  {
    title: 'Responsible Breeders',
    icon: 'breeders',
  },
  {
    title: 'Health Guarantee',
    icon: 'health',
  },
  {
    title: 'Excellent Customer Service',
    icon: 'concierge',
  },
  {
    title: 'Secure and Simple Process',
    icon: 'secure',
  },
  {
    title: 'Pickup & Delivery',
    icon: 'travel',
  },
]

const Why = () => {
  const router = useRouter()

  return (
    <div className={s.why}>
      <div className={s.why_container}>
        <div className={s.why_container_titles}>
          <h2 className={s.why_title}>Why Mawoo Pets? </h2>
          <p className={s.why_sub}>
            We pride ourselves on bringing healthy puppies from trusted breeders
            to loving forever homes.
          </p>
        </div>

        <div className={s.why_features}>
          {features.map((feature, i) => (
            <div key={i} className={s.why_feature}>
              <div className={s.why_feature_icon}>
                <img
                  src={`/icons/${feature.icon}.svg`}
                  alt={feature.title}
                  className={s.why_feature_icon_img}
                />
              </div>
              <h3 className={s.why_feature_title}>{feature.title}</h3>
            </div>
          ))}
        </div>

        <Button
          variant="tertiary"
          className={s.btn}
          onClick={() => router.push('/why-mawoo-pets')}
        >
          Discover the Mawoo Difference
        </Button>
      </div>
    </div>
  )
}

export default Why
